import { Modal } from "react-bootstrap";
import useModalStore from "store/modal";
import { ButtonSolid } from "styles/common/ButtonStyle";
import styled from "styled-components";

const CustomModal = () => {
  const modalStore = useModalStore();
  const { show, title, content, buttonText, gradientHeader, dense, dialogClassName } = modalStore;
  const isExternalLink = typeof content === "string" && content.includes("http");

  const ModalHeaderGradient = styled(Modal.Header)`
    background: ${(props) => props.theme.colors.primary.gradient};
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  `;

  const closeModal = () => {
    modalStore.closeModal();
  };

  const closeModalWithAction = () => {
    if (modalStore.buttonCallback) {
      modalStore.buttonCallback();
    }
    modalStore.closeModal();
  };

  return (
    <Modal show={show} fullscreen={isExternalLink} onHide={closeModal} dialogClassName={dialogClassName} >
      {
        gradientHeader ? (
          <ModalHeaderGradient closeButton>
            <Modal.Title>{title}</Modal.Title>
          </ModalHeaderGradient>  
        ) :
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      }
      <Modal.Body style={{ padding: (isExternalLink || dense) && 0, overlfowY: "hidden" }}>
        {isExternalLink ? (
          <iframe src={content} width="100%" height="100%" title="iframe" />
        ) : (
          content
        )}
      </Modal.Body>
      {buttonText && (
        <Modal.Footer>
          <ButtonSolid
            onClick={closeModalWithAction}
            fontSize="12px"
            fontWeight="500"
          >
            {buttonText}
          </ButtonSolid>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
